var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTherapists(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.975,
    height: 18.87,
    viewBox: "0 0 17.975 18.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_394",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 394",
    d: "M14.572,12.111l0,0c-.057-.024-.112-.052-.17-.075a5.414,5.414,0,0,0,2.074-4.258,4.783,4.783,0,0,0-.04-.57.855.855,0,0,0,.034-.11l.254-2.168a2.718,2.718,0,0,0-2.209-2.985l-.714-.13a15.309,15.309,0,0,0-5.5,0l-.715.13A2.718,2.718,0,0,0,5.374,4.928L5.629,7.1a.855.855,0,0,0,.034.11,4.783,4.783,0,0,0-.04.57A5.414,5.414,0,0,0,7.7,12.034c-.058.023-.113.051-.17.075l0,0a8.995,8.995,0,0,0-5.457,7.321.9.9,0,1,0,1.8.2,7.187,7.187,0,0,1,3.811-5.592l2.734,2.734a.9.9,0,0,0,1.279,0l2.734-2.734a7.187,7.187,0,0,1,3.812,5.592.9.9,0,0,0,.9.806.947.947,0,0,0,.1-.005.9.9,0,0,0,.8-1,8.995,8.995,0,0,0-5.457-7.321ZM7.17,4.717a.906.906,0,0,1,.736-.995l.715-.13a13.5,13.5,0,0,1,4.853,0l.714.13a.906.906,0,0,1,.736.995l-.161,1.369H7.331Zm3.877,10.135L9.555,13.36a7.1,7.1,0,0,1,2.984,0Zm0-3.459a3.621,3.621,0,0,1-3.615-3.5h7.23a3.621,3.621,0,0,1-3.615,3.5Z",
    transform: "translate(-2.06 -1.564)",
    fill: "#92929d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTherapists);
export default __webpack_public_path__ + "static/media/therapists.86023b45.svg";
export { ForwardRef as ReactComponent };